import React from 'react';
import { Clock } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full bg-[#4C1D95] text-white py-12 px-4 sm:py-16 sm:px-6 md:py-28" data-id="element-127">
      <div className="max-w-5xl mx-auto" data-id="element-128">
        {/* The Rule */}
        <div className="max-w-3xl mx-auto text-center mb-12 sm:mb-16" data-id="element-129">
          <div className="inline-flex items-center justify-center p-2.5 bg-[#7C3AED]/30 rounded-full mb-4" data-id="element-130">
            <Clock className="w-6 h-6 text-[#A3E635]" data-id="element-131" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold mb-6" data-id="element-132">
            La Regla 24–48h
          </h2>
          <p className="text-xl text-purple-200 mb-8" data-id="element-133">
            Tu cuerpo te habla claro. Solo tienes que escuchar:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left" data-id="element-134">
            <div className="bg-[#5B21B6] p-5 rounded-lg border border-[#7C3AED]" data-id="element-135">
              <div className="flex items-center mb-2" data-id="element-136">
                <div className="w-3 h-3 rounded-full bg-[#84CC16] mr-3" data-id="element-137"></div>
                <h3 className="font-bold text-lg" data-id="element-138">Luz Verde</h3>
              </div>
              <p className="text-purple-200" data-id="element-139">
                Igual o mejor a las 24h:{' '}
                <span className="text-white font-medium" data-id="element-140">vas bien.</span>
              </p>
            </div>
            <div className="bg-[#5B21B6] p-5 rounded-lg border border-[#7C3AED]" data-id="element-141">
              <div className="flex items-center mb-2" data-id="element-142">
                <div className="w-3 h-3 rounded-full bg-[#EF4444] mr-3" data-id="element-143"></div>
                <h3 className="font-bold text-lg" data-id="element-144">Luz Roja</h3>
              </div>
              <p className="text-purple-200" data-id="element-145">
                Peor a las 24h:{' '}
                <span className="text-white font-medium" data-id="element-146">te pasaste.</span>
              </p>
            </div>
          </div>
        </div>

        {/* The Matrix */}
        <div className="relative bg-[#F5F0E6] text-[#333333] rounded-2xl sm:rounded-3xl p-6 sm:p-10 md:p-12 overflow-hidden" data-id="element-147">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#7C3AED]/10 rounded-full -mr-32 -mt-32 blur-3xl" data-id="element-148"></div>

          <div className="relative z-10" data-id="element-149">
            <div className="text-center mb-8" data-id="element-150">
              <span className="text-[#7C3AED] font-bold tracking-widest uppercase text-sm" data-id="element-151">
                El Método
              </span>
              <h3 className="text-3xl md:text-4xl font-serif font-bold mt-2 mb-4 text-[#4C1D95]" data-id="element-152">
                La Matriz 4C
              </h3>
              <p className="text-lg text-[#555555] max-w-2xl mx-auto" data-id="element-153">
                No hagas "de todo". Haz lo que toca en tu fase.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-154">
              {[{
              title: 'Calmar',
              desc: 'Bajar la amenaza',
              icon: '01'
            }, {
              title: 'Conectar',
              desc: 'Recuperar control',
              icon: '02'
            }, {
              title: 'Coordinar',
              desc: 'Integrar movimiento',
              icon: '03'
            }, {
              title: 'Consolidar',
              desc: 'Volver a la carga',
              icon: '04'
            }].map((phase, i) => <div key={i} className="bg-white p-4 rounded-xl shadow-sm border border-[#E8E3D9] flex flex-col items-center text-center" data-id="element-155">
                  <span className="text-3xl font-bold text-[#7C3AED]/20 mb-2" data-id="element-156">
                    {phase.icon}
                  </span>
                  <h4 className="text-lg font-bold text-[#4C1D95] mb-1" data-id="element-157">
                    {phase.title}
                  </h4>
                  <p className="text-sm text-[#666666]" data-id="element-158">{phase.desc}</p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}